import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { isLogged } from '@food/auth/build/dist/logic/auth';
import { UserData, UserDataInterface } from '@food/auth/build/dist/components/UserData';
import {
	// Abbonamento__C_Rivista__C_Enum,
	AbbonamentoEdge,
	Abbonamento,
} from '../server-types';
import * as Sentry from '@sentry/browser';
// import {config} from "../utils/config";

export type TUserExtendedData = UserDataInterface['userData'] & {
	abbonamenti: ReadonlyArray<Pick<Abbonamento, 'id' | 'Fine' | 'Giorni_alla_scadenza'>>;
};

interface IUserExtendedDataProps {
	children: (
		loading: boolean,
		extendedUserData: TUserExtendedData | null,
	) => JSX.Element;
}

export const additionalUserDataQuery = gql`
	query AdditionalUserDataQuery {
		abbonamenti(filter: { isActive: true, referenteIsCurrentUser: true }) {
			edges {
				node {
					id
					Fine
					Giorni_alla_scadenza
				}
			}
		}
	}
`;

const UserExtendedData: React.FC<IUserExtendedDataProps> = ({ children }) => (
	<UserData>
		{({ loading, userData }) => {
			if (!isLogged()) {
				return children(false, null);
			}
			if (loading) {
				return children(true, null);
			}
			return (
				<Query<any> query={additionalUserDataQuery} errorPolicy={'all'}>
					{({ loading, data, error }) => {
						if (loading) {
							return children(true, null);
						}

						if (error) {
							Sentry.captureException(error);
							console.error(error);
							return children(
								false,
								userData
									? {
											...userData,
											abbonamenti: [],
									  }
									: null,
							);
						}

						return children(false, {
							...userData,
							abbonamenti: data.abbonamenti.edges.map(
								(obj: AbbonamentoEdge) => obj.node,
							),
						});
					}}
				</Query>
			);
		}}
	</UserData>
);

export { UserExtendedData };
